import { getNewsletterBannerTemplate, getVueNewsletterBannerTemplate } from "../../shortcodes/templates";

let newsletterBanner = null;
const visualizeNewsletterBanner = content => {
  newsletterBanner = content.querySelectorAll('[data-wrapper-id="newsletter-banner"]');
  if (newsletterBanner.length > 0) {
    newsletterBanner.forEach(item => {
      item.innerHTML = getNewsletterBannerTemplate();
    });
  }
};

const serializeNewsletterBanner = content => {
  const newsletterBannerWidget = content.querySelectorAll('[data-wrapper-id="newsletter-banner"]');
  if (newsletterBannerWidget.length > 0) {
    newsletterBannerWidget.forEach(item => {
      const bannerData = item.getAttribute("data-newsletter-banner-data");
      item.innerHTML = getVueNewsletterBannerTemplate(bannerData);
    });
  }
};

export { visualizeNewsletterBanner, serializeNewsletterBanner };
